// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/trip.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/trip.proto.
 */
export const file_travplaces_v1_trip: GenFile = /*@__PURE__*/
  fileDesc("Chh0cmF2cGxhY2VzL3YxL3RyaXAucHJvdG8SDXRyYXZwbGFjZXMudjEi+gEKC1RyaXBTdW1tYXJ5EgoKAmlkGAEgASgJEg8KB2NpdHlfaWQYAiABKAkSEQoJY2l0eV9uYW1lGAMgASgJEgwKBG5hbWUYBCABKAkSEQoJZGF5X2NvdW50GAUgASgFEhQKDHBsYW5uZWRfZGF5cxgGIAEoBRISCgpzdG9wX2NvdW50GAcgASgFEi4KCmNyZWF0ZWRfYXQYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYCSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhAKCHNhdmVkX2J5GAogASgJIlwKBFRyaXASKwoHc3VtbWFyeRgBIAEoCzIaLnRyYXZwbGFjZXMudjEuVHJpcFN1bW1hcnkSFAoMcmVxdWVzdF9qc29uGAIgASgJEhEKCXBsYW5fanNvbhgDIAEoCSI3ChBMaXN0VHJpcHNSZXF1ZXN0EhEKCW93bmVyX2tleRgBIAEoCRIQCghldmVyeW9uZRgCIAEoCCI+ChFMaXN0VHJpcHNSZXNwb25zZRIpCgV0cmlwcxgBIAMoCzIaLnRyYXZwbGFjZXMudjEuVHJpcFN1bW1hcnkiHAoOR2V0VHJpcFJlcXVlc3QSCgoCaWQYASABKAkiNAoPR2V0VHJpcFJlc3BvbnNlEiEKBHRyaXAYASABKAsyEy50cmF2cGxhY2VzLnYxLlRyaXAibAoPU2F2ZVRyaXBSZXF1ZXN0EhEKCW93bmVyX2tleRgBIAEoCRIPCgdjaXR5X2lkGAIgASgJEgwKBG5hbWUYAyABKAkSFAoMcmVxdWVzdF9qc29uGAQgASgJEhEKCXBsYW5fanNvbhgFIAEoCSI1ChBTYXZlVHJpcFJlc3BvbnNlEiEKBHRyaXAYASABKAsyEy50cmF2cGxhY2VzLnYxLlRyaXAioAEKEVVwZGF0ZVRyaXBSZXF1ZXN0EgoKAmlkGAEgASgJEhEKCW93bmVyX2tleRgCIAEoCRIRCgRuYW1lGAMgASgJSACIAQESGQoMcmVxdWVzdF9qc29uGAQgASgJSAGIAQESFgoJcGxhbl9qc29uGAUgASgJSAKIAQFCBwoFX25hbWVCDwoNX3JlcXVlc3RfanNvbkIMCgpfcGxhbl9qc29uIjcKElVwZGF0ZVRyaXBSZXNwb25zZRIhCgR0cmlwGAEgASgLMhMudHJhdnBsYWNlcy52MS5UcmlwIjIKEURlbGV0ZVRyaXBSZXF1ZXN0EgoKAmlkGAEgASgJEhEKCW93bmVyX2tleRgCIAEoCSIUChJEZWxldGVUcmlwUmVzcG9uc2UiJwoPUGxhblRyaXBSZXF1ZXN0EhQKDHJlcXVlc3RfanNvbhgBIAEoCSIlChBQbGFuVHJpcFJlc3BvbnNlEhEKCXBsYW5fanNvbhgBIAEoCSJSChJQbGFuVHJpcERheVJlcXVlc3QSFAoMcmVxdWVzdF9qc29uGAEgASgJEg0KBWluZGV4GAIgASgFEhcKD2FscmVhZHlfcGxhbm5lZBgDIAMoCSInChNQbGFuVHJpcERheVJlc3BvbnNlEhAKCGRheV9qc29uGAEgASgJMpgFCgtUcmlwU2VydmljZRJbCglMaXN0VHJpcHMSHy50cmF2cGxhY2VzLnYxLkxpc3RUcmlwc1JlcXVlc3QaIC50cmF2cGxhY2VzLnYxLkxpc3RUcmlwc1Jlc3BvbnNlIguK6jADCgEfkOowARJVCgdHZXRUcmlwEh0udHJhdnBsYWNlcy52MS5HZXRUcmlwUmVxdWVzdBoeLnRyYXZwbGFjZXMudjEuR2V0VHJpcFJlc3BvbnNlIguK6jADCgEfkOowARJYCghTYXZlVHJpcBIeLnRyYXZwbGFjZXMudjEuU2F2ZVRyaXBSZXF1ZXN0Gh8udHJhdnBsYWNlcy52MS5TYXZlVHJpcFJlc3BvbnNlIguK6jADCgEfkOowAhJeCgpVcGRhdGVUcmlwEiAudHJhdnBsYWNlcy52MS5VcGRhdGVUcmlwUmVxdWVzdBohLnRyYXZwbGFjZXMudjEuVXBkYXRlVHJpcFJlc3BvbnNlIguK6jADCgEfkOowAhJeCgpEZWxldGVUcmlwEiAudHJhdnBsYWNlcy52MS5EZWxldGVUcmlwUmVxdWVzdBohLnRyYXZwbGFjZXMudjEuRGVsZXRlVHJpcFJlc3BvbnNlIguK6jADCgEfkOowAhJYCghQbGFuVHJpcBIeLnRyYXZwbGFjZXMudjEuUGxhblRyaXBSZXF1ZXN0Gh8udHJhdnBsYWNlcy52MS5QbGFuVHJpcFJlc3BvbnNlIguK6jADCgEekOowARJhCgtQbGFuVHJpcERheRIhLnRyYXZwbGFjZXMudjEuUGxhblRyaXBEYXlSZXF1ZXN0GiIudHJhdnBsYWNlcy52MS5QbGFuVHJpcERheVJlc3BvbnNlIguK6jADCgEekOowAUKkAQoRY29tLnRyYXZwbGFjZXMudjFCCVRyaXBQcm90b1ABWi90cmF2cGxhY2VzL2dlbi9wcm90by90cmF2cGxhY2VzL3YxO3RyYXZwbGFjZXN2MaICA1RYWKoCDVRyYXZwbGFjZXMuVjHKAg1UcmF2cGxhY2VzXFYx4gIZVHJhdnBsYWNlc1xWMVxHUEJNZXRhZGF0YeoCDlRyYXZwbGFjZXM6OlYxYgZwcm90bzM", [file_travplaces_v1_audit, file_travplaces_v1_authz, file_google_protobuf_timestamp]);

/**
 * TripSummary is the list-screen shape: identity plus the few counts derived
 * from the stored plan. Mirrors SavedTripSummary in the legacy types.
 *
 * @generated from message travplaces.v1.TripSummary
 */
export type TripSummary = Message<"travplaces.v1.TripSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string city_id = 2;
   */
  cityId: string;

  /**
   * @generated from field: string city_name = 3;
   */
  cityName: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: int32 day_count = 5;
   */
  dayCount: number;

  /**
   * Days that actually produced a plan, which may be fewer.
   *
   * @generated from field: int32 planned_days = 6;
   */
  plannedDays: number;

  /**
   * @generated from field: int32 stop_count = 7;
   */
  stopCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * Who saved it, from their login. Empty on operations saved before the
   * app recorded it — see SavedRouteSummary, which carries the same.
   *
   * @generated from field: string saved_by = 10;
   */
  savedBy: string;
};

/**
 * Describes the message travplaces.v1.TripSummary.
 * Use `create(TripSummarySchema)` to create a new message.
 */
export const TripSummarySchema: GenMessage<TripSummary> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 0);

/**
 * Trip is the detail shape: the summary plus the full request and plan, each
 * as the verbatim JSON the client saved. Mirrors SavedTrip.
 *
 * @generated from message travplaces.v1.Trip
 */
export type Trip = Message<"travplaces.v1.Trip"> & {
  /**
   * @generated from field: travplaces.v1.TripSummary summary = 1;
   */
  summary?: TripSummary | undefined;

  /**
   * @generated from field: string request_json = 2;
   */
  requestJson: string;

  /**
   * @generated from field: string plan_json = 3;
   */
  planJson: string;
};

/**
 * Describes the message travplaces.v1.Trip.
 * Use `create(TripSchema)` to create a new message.
 */
export const TripSchema: GenMessage<Trip> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 1);

/**
 * @generated from message travplaces.v1.ListTripsRequest
 */
export type ListTripsRequest = Message<"travplaces.v1.ListTripsRequest"> & {
  /**
   * @generated from field: string owner_key = 1;
   */
  ownerKey: string;

  /**
   * Everybody's saved operations. See ListSavedRoutesRequest.everyone.
   *
   * @generated from field: bool everyone = 2;
   */
  everyone: boolean;
};

/**
 * Describes the message travplaces.v1.ListTripsRequest.
 * Use `create(ListTripsRequestSchema)` to create a new message.
 */
export const ListTripsRequestSchema: GenMessage<ListTripsRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 2);

/**
 * @generated from message travplaces.v1.ListTripsResponse
 */
export type ListTripsResponse = Message<"travplaces.v1.ListTripsResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.TripSummary trips = 1;
   */
  trips: TripSummary[];
};

/**
 * Describes the message travplaces.v1.ListTripsResponse.
 * Use `create(ListTripsResponseSchema)` to create a new message.
 */
export const ListTripsResponseSchema: GenMessage<ListTripsResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 3);

/**
 * @generated from message travplaces.v1.GetTripRequest
 */
export type GetTripRequest = Message<"travplaces.v1.GetTripRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.GetTripRequest.
 * Use `create(GetTripRequestSchema)` to create a new message.
 */
export const GetTripRequestSchema: GenMessage<GetTripRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 4);

/**
 * @generated from message travplaces.v1.GetTripResponse
 */
export type GetTripResponse = Message<"travplaces.v1.GetTripResponse"> & {
  /**
   * @generated from field: travplaces.v1.Trip trip = 1;
   */
  trip?: Trip | undefined;
};

/**
 * Describes the message travplaces.v1.GetTripResponse.
 * Use `create(GetTripResponseSchema)` to create a new message.
 */
export const GetTripResponseSchema: GenMessage<GetTripResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 5);

/**
 * @generated from message travplaces.v1.SaveTripRequest
 */
export type SaveTripRequest = Message<"travplaces.v1.SaveTripRequest"> & {
  /**
   * @generated from field: string owner_key = 1;
   */
  ownerKey: string;

  /**
   * @generated from field: string city_id = 2;
   */
  cityId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * The TripRequest and TripPlan, as JSON.
   *
   * @generated from field: string request_json = 4;
   */
  requestJson: string;

  /**
   * @generated from field: string plan_json = 5;
   */
  planJson: string;
};

/**
 * Describes the message travplaces.v1.SaveTripRequest.
 * Use `create(SaveTripRequestSchema)` to create a new message.
 */
export const SaveTripRequestSchema: GenMessage<SaveTripRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 6);

/**
 * @generated from message travplaces.v1.SaveTripResponse
 */
export type SaveTripResponse = Message<"travplaces.v1.SaveTripResponse"> & {
  /**
   * @generated from field: travplaces.v1.Trip trip = 1;
   */
  trip?: Trip | undefined;
};

/**
 * Describes the message travplaces.v1.SaveTripResponse.
 * Use `create(SaveTripResponseSchema)` to create a new message.
 */
export const SaveTripResponseSchema: GenMessage<SaveTripResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 7);

/**
 * @generated from message travplaces.v1.UpdateTripRequest
 */
export type UpdateTripRequest = Message<"travplaces.v1.UpdateTripRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string owner_key = 2;
   */
  ownerKey: string;

  /**
   * Each is a patch: absent leaves the stored value untouched.
   *
   * @generated from field: optional string name = 3;
   */
  name?: string | undefined;

  /**
   * @generated from field: optional string request_json = 4;
   */
  requestJson?: string | undefined;

  /**
   * @generated from field: optional string plan_json = 5;
   */
  planJson?: string | undefined;
};

/**
 * Describes the message travplaces.v1.UpdateTripRequest.
 * Use `create(UpdateTripRequestSchema)` to create a new message.
 */
export const UpdateTripRequestSchema: GenMessage<UpdateTripRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 8);

/**
 * @generated from message travplaces.v1.UpdateTripResponse
 */
export type UpdateTripResponse = Message<"travplaces.v1.UpdateTripResponse"> & {
  /**
   * @generated from field: travplaces.v1.Trip trip = 1;
   */
  trip?: Trip | undefined;
};

/**
 * Describes the message travplaces.v1.UpdateTripResponse.
 * Use `create(UpdateTripResponseSchema)` to create a new message.
 */
export const UpdateTripResponseSchema: GenMessage<UpdateTripResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 9);

/**
 * @generated from message travplaces.v1.DeleteTripRequest
 */
export type DeleteTripRequest = Message<"travplaces.v1.DeleteTripRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string owner_key = 2;
   */
  ownerKey: string;
};

/**
 * Describes the message travplaces.v1.DeleteTripRequest.
 * Use `create(DeleteTripRequestSchema)` to create a new message.
 */
export const DeleteTripRequestSchema: GenMessage<DeleteTripRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 10);

/**
 * @generated from message travplaces.v1.DeleteTripResponse
 */
export type DeleteTripResponse = Message<"travplaces.v1.DeleteTripResponse"> & {
};

/**
 * Describes the message travplaces.v1.DeleteTripResponse.
 * Use `create(DeleteTripResponseSchema)` to create a new message.
 */
export const DeleteTripResponseSchema: GenMessage<DeleteTripResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 11);

/**
 * @generated from message travplaces.v1.PlanTripRequest
 */
export type PlanTripRequest = Message<"travplaces.v1.PlanTripRequest"> & {
  /**
   * A TripRequest, as JSON: defaults plus one entry per day.
   *
   * @generated from field: string request_json = 1;
   */
  requestJson: string;
};

/**
 * Describes the message travplaces.v1.PlanTripRequest.
 * Use `create(PlanTripRequestSchema)` to create a new message.
 */
export const PlanTripRequestSchema: GenMessage<PlanTripRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 12);

/**
 * @generated from message travplaces.v1.PlanTripResponse
 */
export type PlanTripResponse = Message<"travplaces.v1.PlanTripResponse"> & {
  /**
   * A TripPlan, as JSON.
   *
   * @generated from field: string plan_json = 1;
   */
  planJson: string;
};

/**
 * Describes the message travplaces.v1.PlanTripResponse.
 * Use `create(PlanTripResponseSchema)` to create a new message.
 */
export const PlanTripResponseSchema: GenMessage<PlanTripResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 13);

/**
 * @generated from message travplaces.v1.PlanTripDayRequest
 */
export type PlanTripDayRequest = Message<"travplaces.v1.PlanTripDayRequest"> & {
  /**
   * The whole TripRequest, as JSON — a day is planned against its neighbours.
   *
   * @generated from field: string request_json = 1;
   */
  requestJson: string;

  /**
   * Which day to re-plan.
   *
   * @generated from field: int32 index = 2;
   */
  index: number;

  /**
   * Places the other days already hold, so this day avoids repeating them.
   *
   * @generated from field: repeated string already_planned = 3;
   */
  alreadyPlanned: string[];
};

/**
 * Describes the message travplaces.v1.PlanTripDayRequest.
 * Use `create(PlanTripDayRequestSchema)` to create a new message.
 */
export const PlanTripDayRequestSchema: GenMessage<PlanTripDayRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 14);

/**
 * @generated from message travplaces.v1.PlanTripDayResponse
 */
export type PlanTripDayResponse = Message<"travplaces.v1.PlanTripDayResponse"> & {
  /**
   * A single TripDay, as JSON.
   *
   * @generated from field: string day_json = 1;
   */
  dayJson: string;
};

/**
 * Describes the message travplaces.v1.PlanTripDayResponse.
 * Use `create(PlanTripDayResponseSchema)` to create a new message.
 */
export const PlanTripDayResponseSchema: GenMessage<PlanTripDayResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_trip, 15);

/**
 * TripService stores and re-plans multi-day trips, scoped to an opaque
 * browser owner_key.
 *
 * @generated from service travplaces.v1.TripService
 */
export const TripService: GenService<{
  /**
   * ListTrips returns every trip for an owner_key, newest first.
   *
   * @generated from rpc travplaces.v1.TripService.ListTrips
   */
  listTrips: {
    methodKind: "unary";
    input: typeof ListTripsRequestSchema;
    output: typeof ListTripsResponseSchema;
  },
  /**
   * GetTrip returns one trip by id (owner_key not checked, so a link opens).
   *
   * @generated from rpc travplaces.v1.TripService.GetTrip
   */
  getTrip: {
    methodKind: "unary";
    input: typeof GetTripRequestSchema;
    output: typeof GetTripResponseSchema;
  },
  /**
   * SaveTrip persists a planned trip and returns it whole.
   *
   * @generated from rpc travplaces.v1.TripService.SaveTrip
   */
  saveTrip: {
    methodKind: "unary";
    input: typeof SaveTripRequestSchema;
    output: typeof SaveTripResponseSchema;
  },
  /**
   * UpdateTrip patches name/request/plan; unset fields are left as-is.
   *
   * @generated from rpc travplaces.v1.TripService.UpdateTrip
   */
  updateTrip: {
    methodKind: "unary";
    input: typeof UpdateTripRequestSchema;
    output: typeof UpdateTripResponseSchema;
  },
  /**
   * DeleteTrip removes a trip owned by owner_key.
   *
   * @generated from rpc travplaces.v1.TripService.DeleteTrip
   */
  deleteTrip: {
    methodKind: "unary";
    input: typeof DeleteTripRequestSchema;
    output: typeof DeleteTripResponseSchema;
  },
  /**
   * PlanTrip plans a whole trip from a TripRequest JSON, returning a TripPlan.
   *
   * @generated from rpc travplaces.v1.TripService.PlanTrip
   */
  planTrip: {
    methodKind: "unary";
    input: typeof PlanTripRequestSchema;
    output: typeof PlanTripResponseSchema;
  },
  /**
   * PlanTripDay re-plans one day of a trip without disturbing the others.
   *
   * @generated from rpc travplaces.v1.TripService.PlanTripDay
   */
  planTripDay: {
    methodKind: "unary";
    input: typeof PlanTripDayRequestSchema;
    output: typeof PlanTripDayResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_trip, 0);

